<template lang="pug">
  v-carousel(
    cycle
    height="400"
    hide-delimiter-background
    show-arrows-on-hover)
    v-carousel-item(
      v-for="(slide, i) in photos",
      :key="i",
      :src="slide")
</template>

<script>
export default {
  name: 'ComplexCarousel',
  props: {
    photos: {
      type: Array,
      default: () => [],
      required: true
    }
  }
}
</script>
